import { getColorScheme } from '../../colors';
import { pxToRem } from '../../../../utils';
export var toolbarMenuItemSubmenuIndicatorStyles = {
  root: function root(_ref) {
    var v = _ref.variables;
    var colors = getColorScheme(v.colorScheme);
    return {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      color: v.menuItemForeground || colors.foreground1,
      width: pxToRem(16),
      height: '100%',
      position: 'absolute',
      right: pxToRem(7),
      top: 0
    };
  }
};